export default "__VITE_ASSET__DyiGNhim__"